import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { ReactNode } from "react";
import { ThemeContextProvider } from "./ThemeContext";
import { useV2Theme } from "../hooks/useV2Theme";
import { v2DarkTheme, v2LightTheme } from "./v2Theme";
import { darkTokens, lightTokens } from "./v2Tokens";

function tokensToCss(tokens: Record<string, string>): Record<string, string> {
  const css: Record<string, string> = {};
  for (const [key, value] of Object.entries(tokens)) {
    css[key] = value;
  }
  return css;
}

function InnerProvider({ children }: { children: ReactNode }) {
  const { mode } = useV2Theme();
  const muiTheme = mode === "dark" ? v2DarkTheme : v2LightTheme;
  const tokens = mode === "dark" ? darkTokens : lightTokens;

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {mode === "dark" && (
        <style>{`
          [data-theme="dark"] *::-webkit-scrollbar { width: 8px; height: 8px; }
          [data-theme="dark"] *::-webkit-scrollbar-track { background: transparent; }
          [data-theme="dark"] *::-webkit-scrollbar-thumb { background: rgba(148,163,184,0.2); border-radius: 4px; }
          [data-theme="dark"] *::-webkit-scrollbar-thumb:hover { background: rgba(148,163,184,0.35); }
          [data-theme="dark"] *::-webkit-scrollbar-corner { background: transparent; }
        `}</style>
      )}
      <div data-theme={mode} style={tokensToCss(tokens) as React.CSSProperties}>
        {children}
      </div>
    </ThemeProvider>
  );
}

export function V2ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeContextProvider>
      <InnerProvider>{children}</InnerProvider>
    </ThemeContextProvider>
  );
}
